/* eslint-disable no-lonely-if */
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { ROLE_SECRET_KEY } from 'utility/constants'
import CryptoJS from 'crypto-js'
import authService from 'services/auth.service'
import { toast } from 'react-toastify'

interface IProps {
  Component: React.ComponentType
  allowAll?: boolean
  allowRestaurantStaff?: boolean
  isNotAllowedAfterLogin?: boolean
}

export default function PrivateRoute(props: IProps) {
  const { Component, allowAll, allowRestaurantStaff, isNotAllowedAfterLogin } =
    props
  const [roleId, setRoleId] = React.useState(0)
  const navigate = useNavigate()
  const storageData = localStorage.length

  React.useEffect(() => {
    const validateAndRefreshToken = async () => {
      const token = localStorage.getItem('loginAuthToken')

      // If no token exists, redirect to login
      if (!token) {
        if (!isNotAllowedAfterLogin) {
          navigate('/')
        }
        return
      }

      try {
        // Check if token is expired
        if (authService.isTokenExpired(token)) {
          // Try to refresh the token
          const { data } = await authService.refreshToken()
          if (data?.data?.token) {
            // Token refreshed successfully
            localStorage.setItem('loginAuthToken', data.data.token)
          } else {
            // Refresh failed
            throw new Error('Token refresh failed')
          }
        }

        // Token is valid or was refreshed successfully
        if (localStorage.getItem('roleId')) {
          setRoleId(
            +CryptoJS.AES.decrypt(
              localStorage.getItem('roleId'),
              ROLE_SECRET_KEY
            )?.toString(CryptoJS.enc.Utf8)
          )

          // Check role-based access
          const decryptedRoleId = +CryptoJS.AES.decrypt(
            localStorage.getItem('roleId'),
            ROLE_SECRET_KEY
          )?.toString(CryptoJS.enc.Utf8)

          if (
            localStorage.getItem('isGMEnable') !== 'true' &&
            decryptedRoleId !== 1 &&
            !allowAll &&
            !allowRestaurantStaff
          ) {
            navigate('/unauthorized')
            return
          }

          if (
            localStorage.getItem('isGMEnable') !== 'true' &&
            (decryptedRoleId === 6 || decryptedRoleId === 7) &&
            allowRestaurantStaff
          ) {
            navigate('/unauthorized')
            return
          }
        } else if (!isNotAllowedAfterLogin) {
          navigate('/')
        }
      } catch (error) {
        console.error('Token validation failed:', error)
        toast.error('Session expired. Please login again.')
        authService.logout()
        localStorage.clear()
      }
    }

    validateAndRefreshToken()
  }, [
    navigate,
    roleId,
    allowAll,
    storageData,
    allowRestaurantStaff,
    isNotAllowedAfterLogin,
  ])

  return (
    <>
      <Component />
    </>
  )
}
